import { render, staticRenderFns } from "./roleForm.vue?vue&type=template&id=30b4c016&scoped=true&"
import script from "./roleForm.vue?vue&type=script&lang=js&"
export * from "./roleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b4c016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b4c016')) {
      api.createRecord('30b4c016', component.options)
    } else {
      api.reload('30b4c016', component.options)
    }
    module.hot.accept("./roleForm.vue?vue&type=template&id=30b4c016&scoped=true&", function () {
      api.rerender('30b4c016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemMgr/roleMgr/components/roleForm.vue"
export default component.exports